import { Component, Prop, Vue } from 'vue-property-decorator';
import store from "Store/index"
import { OrderingListUserPermissionViewModel } from 'Api/CoreApi';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';
import { mixins } from 'vue-class-component';

@Component({
    template: "#ordering-list-user-overview-template"
})
export default class OrderingListUserOverviewComponent extends mixins(BaseComponent,OrderingListUserMixin){

   


    async created(){
        if(!this.isAdvancedAdmin) return;
        this.setLoading();
        await store.dispatch.orderingListUser.load();                
        this.setLoaded();
     }
 

    get list() : OrderingListUserPermissionViewModel[] {
        return store.state.orderingListUser.Users;
    }
   
    
}

Vue.component('ordering-list-user-overview', OrderingListUserOverviewComponent);